import {
    BrowserRouter as Router,
} from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import AuthProvider from './Providers/AuthProvider'
import 'react-toastify/dist/ReactToastify.css';
import ConfigProvider from './Providers/ConfigProvider';
import '@fontsource/inter';
import { RegistrationProvider } from './Providers/RegistrationProvider';
import { ParamsProvider } from './Providers/ParamsProvider';

const NewApp = () => {
    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <Router>
                <ConfigProvider>
                    <ParamsProvider>
                        <RegistrationProvider>
                            <AuthProvider />
                        </RegistrationProvider>
                    </ParamsProvider>
                </ConfigProvider>
            </Router>
        </>
    )
}

export default NewApp